/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import XDownloader from './Classes/XDownloader';
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var downloaderInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {


  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  new ResponsiveTablesLight({
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.ns-table-wrap table'
  });

  downloaderInstance = new XDownloader({
    downloadText: "XLS", //Can be empty if you want to use an icon instead
    backgroundColor: "E2DED6", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-tabellenhg', //Class of colored cells
    borderColor: '000000', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'title', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-linie_fein'
  });

});

document.addEventListener("noteLoaded", function () {
  new ResponsiveTablesLight({
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.ns-table-wrap table'
  });
});
